class WhereBuy {
  /**
   * инициализация точек на карте
   * @param {array} массив данных по точкам вида [{id: int, lat: float, lng: float}]
   */
  setMapPoints(mapPoints) {
    globalStorage.defaultMapPoints = mapPoints;
    app.dealer.setMarkers();
  }

  /**
   * Ключ для яндекс.карт
   * Без этого ключа функция поиска координат города не работает!
   */
  setApiKeyYmaps(apikey) {
    globalStorage.ymapsApiKey = apikey;
    app.dealer.initMap();
  }

  /**
   * Центрируем карту по названию города, точки не ставим
   * @param {string} Название города
   */
  setCity(city) {
    globalStorage.defaultMapCity = city;
    app.dealer.setCity(city);
  }

  /**
   * Callback-функция применения фильтра
   * @param {array} массив данных по выбранным значениям фильтра
   * 
   * Срабатывает на ПК и на мобильном при выборе страны/города
   * Срабатывает на мобильном при нажатии кнопки "Применить", либо "Очистить все"
   * Срабатывает на ПК при выборе какой-либо опции в фильтре
   */
  eventApplyFilter = func => {
    globalStorage.callbacks.filterApply = func;
  }

  /**
   * Callback-функция клика мышкой по точке на карте
   * @param {int} id дилера
   * Ожидается html для показа в всплывающем окне
   * с помощью фукнции obWhereBuy.showShopModal(html)
   */
  eventClickPointOnMap = func => {
    globalStorage.callbacks.mapClick = func;
  }
  showShopModal = html => {
    app.dealer.showShopPopup(html);
  }

  /**
   * Callback-функция клика мышкой на иконку сертификата
   * @param {int} id сертификата (дилера)
   * Ожидается массив для передачи в функцию obWhereBuy.showCertificateModal(array)
   */
  eventClickOnCertificate = func => {
    globalStorage.callbacks.certClick = func;
  }
  showCertificateModal = dataArray => {
    app.certificate.showCertificateModal(dataArray);
  }

  /**
   * Функция реинициализации обработчиков - после перезагрузки данных
   * Срабатывает после выполнения функций obWhereBuy.eventApplyFilter
   * и obWhereBuy.showShopModal, но может быть вызвана отдельно
   */
  resetHandlers = () => {
    globalStorage.handlersReset();
  }
}